import type { FC, ReactElement, ReactNode } from 'react'

import './data-point.scss'

const DataPoints: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="data-points">{children}</div>
)

export const DataPoint: FC<{
  header?: string | ReactElement
  value?: string | ReactElement
  values?: string[] | ReactElement[]
}> = ({ header = '', value = '', values = [] }) => (
  <div className="data-point">
    {header && <h4>{header}</h4>}

    {[value, ...values].map((value, idx) => (
      <div className="data-point__value" key={idx}>
        {value}
      </div>
    ))}
  </div>
)

export default DataPoints
